import VisibleComponent from '../VisibleComponent'
import './index.less'

const template = `
     <div class="mtg-ad-logo">
        <img src="https://hybird.rayjump.com/static/icon_mtg_gray.png" alt="" class="mtg-logo">
        <span">${window.navigator.language.indexOf('zh') > -1 ? '广告' : 'AD'}</span>
     </div>
`

/**
 * Ad类
 * @constructor
 * @extends VisibleComponent
 * @param options 构造参数
 */
class Ad extends VisibleComponent {
    constructor(options = {}) {
        super(options)
        this.template = template
        this.init(options)
    }

    init(options) {
        super.init(options)
        this.logoElem = this.element.querySelector('.mtg-logo')
        const {
            logo,
            type = "roundedRect",
            theme = "black",
            position = "rightBottom"
        } = options;
        if (logo === false) {
            this.element.removeChild(this.logoElem)
            return false
        }
        switch (type) {
            case "roundedRect":
                this.element.classList.add("mtg-ad-logo-rounded-rect")
                break;
            case "rightTopRect":
                this.element.classList.add("mtg-ad-logo-right-top-rect")
                break;
            case "leftTopRect":
                this.element.classList.add("mtg-ad-logo-left-top-rect")
                break;
            case "rightBottomRect":
                this.element.classList.add("mtg-ad-logo-right-bottom-rect")
                break;
            case "leftBottomRect":
                this.element.classList.add("mtg-ad-logo-left-bottom-rect")
                break;
            case "rightTopNoRect":
                this.element.classList.add("mtg-ad-logo-right-top-no-rect")
                break;
            case "antidiagonalRect":
                this.element.classList.add("mtg-ad-logo-antidiagonal-rect")
                break;
            case "diagonalRect":
                this.element.classList.add("mtg-ad-logo-diagonal-rect")
                break;
            default:
                this.element.classList.add("mtg-ad-logo-rounded-rect")
        }
        switch (theme) {
            case "black":
                this.element.classList.add("mtg-ad-logo-black")
                break;
            case "white":
                this.element.classList.add("mtg-ad-logo-white")
                break;
            default:
                this.element.classList.add("mtg-ad-logo-black")
        }
        switch (position) {
            case "leftTop":
                this.element.classList.add("mtg-ad-logo-left-top")
                break;
            case "rightTop":
                this.element.classList.add("mtg-ad-logo-right-top")
                break;
            case "leftBottom":
                this.element.classList.add("mtg-ad-logo-left-bottom")
                break;
            case "rightBottom":
                this.element.classList.add("mtg-ad-logo-right-bottom")
                break;
            default:
                this.element.classList.add("mtg-ad-logo-right-bottom")
        }
    }
}

export default Ad